export default __webpack_public_path__ + "static/media/i.788f2f85.jpg";